import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Auth } from 'aws-amplify';
import { renderCellExpand } from '../../../../../common/GridCell/GridCellExpand';
import {
  DataGridContainer,
  FullDivider,
  TypographyLink,
} from '../../../../../ui/styled';
import { useDispatch } from 'react-redux';
import OrganizationContactDialog from './OrganizationContactDialog/OrganizationContactDialog';
import {
  getOrganizationContact,
  newOrganizationContact,
  resetOrganizationContact,
  setNewOrganizationContactForm,
  setOrgIdForContactForm,
} from '../../../../../../redux/organization/organizationTabs/addressAndContacts/organizationContacts/organizationContactsSlice';
import {
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../../../Episode/Episode.Styled';

const OrganizationContacts = (props) => {
  const { orgId, contactList } = props;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openOrganizationContactDialog, setOpenOrganizationContactDialog] =
    useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [contactData, setContactData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    // page: 1,
    // pageSize: 10,
    // sortModel: '',
  });

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    fetchData();
  }, [contactList]);

  const fetchData = async () => {
    setContactData((prveState) => ({ ...prveState, isLoading: true }));
    const json = contactList;
    setContactData((prveState) => ({
      ...prveState,
      isLoading: false,
      data: json?.map((item, index) => ({
        ...item,
        _id: index,
        cntId: item.cntId,
        contactKey: item.contactKey,
        honorific: item.honorific,
        firstName: item.firstName,
        lastName: item.lastName,
        suffix: item.suffix,
        title: item.title,
        workPhone: item.workPhone,
        paroleOfficer: item.paroleOfficer,
        inactive: item.inactive,
      })),
    }));
  };

  const updateOrganizationContact = (params) => {
    const { row } = params;
    const organizationContact = {
      _id: row?._id,
      cntId: row?.cntId,
      orgId: orgId,
      contactKey: row?.contactKey,
      honorific: row?.honorific,
      firstName: row?.firstName,
      lastName: row?.lastName,
      suffix: row?.suffix,
      title: row?.title,
      workPhone: row?.workPhone,
      paroleOfficer: row?.paroleOfficer,
      inactive: row?.inactive,
      addressCity: row?.addressCity,
      createDate: row?.createDate,
      editdate: row?.editdate,
      contactEditedby: row?.contactEditedby,
      contactCreatedby: row?.contactCreatedby,
    };
    dispatch(getOrganizationContact(organizationContact));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenOrganizationContactDialog(true);
  };
  const handelNewOrganizationContactForm = () => {
    dispatch(resetOrganizationContact());
    dispatch(setNewOrganizationContactForm(true));
    dispatch(setOrgIdForContactForm(orgId));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenOrganizationContactDialog(true);
  };

  const columnsData = [
    {
      field: 'cntId',
      headerName: 'Contact ID',
      renderCell: (params) => {
        return (
          <TypographyLink
            variant='h6'
            onClick={() => updateOrganizationContact(params)}
          >
            {params.row.cntId}
          </TypographyLink>
        );
      },
      flex: 1,
    },
    {
      field: 'contactKey',
      headerName: 'Contact Key',
      renderCell: renderCellExpand,
      flex: 1,
    },
    { field: 'honorific', headerName: 'Honorific', flex: 1 },
    { field: 'firstName', headerName: 'First Name', flex: 1 },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
    { field: 'suffix', headerName: 'Suffix', flex: 1 },
    {
      field: 'title',
      headerName: 'Title',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'workPhone',
      headerName: 'Work Phone',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'paroleOfficer',
      headerName: 'Parole Officer',
      type: 'boolean',
      flex: 1,
    },
    { field: 'inactive', headerName: 'InActive', type: 'boolean', flex: 1 },
  ];

  const getTitleAndButton = () => {
    return (
      <>
        <FullDivider />
        <GridContainer container>
          <Grid item xs={6}>
            <NoteHeading variant='h5'>
              To edit Contact please click on Contact Id
            </NoteHeading>
          </Grid>
          <LeftGrid item xs={6}>
            <Button
              variant='contained'
              onClick={() => handelNewOrganizationContactForm()}
            >
              New Contact
            </Button>
          </LeftGrid>
        </GridContainer>
      </>
    );
  };

  const getDataGrid = () => {
    return (
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={columnsData}
          rows={contactData.data}
          // pageSize={contactList.pageSize}
          // page={contactList.page - 1}
          rowCount={contactData.total}
          getRowId={(row) => row._id}
          // paginationMode='server'
          // sortingMode='server'
          // onPageSizeChange={(newPageSize) =>
          //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
          // }
          // onPageChange={(newPage) => {
          //   setContactList((old) => ({ ...old, page: newPage + 1 }));
          // }}
          // rowsPerPageOptions={paginationSize}
          //pagination
          //components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          //onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={contactData.isLoading}
        />
      </DataGridContainer>
    );
  };

  const getOrganizationContactDialog = () => {
    return (
      <>
        <OrganizationContactDialog
          open={openOrganizationContactDialog}
          setOpen={setOpenOrganizationContactDialog}
          authToken={user?.signInUserSession.accessToken.jwtToken}
          openBackdrop={openBackdrop}
        />
      </>
    );
  };

  return (
    <>
      {getTitleAndButton()}
      {getDataGrid()}
      {getOrganizationContactDialog()}
    </>
  );
};

export default OrganizationContacts;
